import { useLlmoComparisonApi } from '@/common/api/modules/llmo'
import { scoreTextColor, signedScore } from '@/common/app/modules/media/sentiment'
import { SentimentResult } from '@/common/model/media/sentiment'
import { signedFixed } from '@/common/util/number'

import GeoScoreCard from '@/components/container/modules/mediaGeo/common/GeoScoreCard'
import GeoSection from '@/components/container/modules/mediaGeo/common/GeoSection'

import SentimentCompetitorTable from './SentimentCompetitorTable'
import SentimentDistributionChart from './SentimentDistributionChart'
import SentimentDistributionTable from './SentimentDistributionTable'
import SentimentInsightsPanel from './SentimentInsightsPanel'
import SentimentPromptList from './SentimentPromptList'

interface Props {
  result: SentimentResult
  siteId: number
  historyId: number
}

// センチメント分析の結果ビュー全体
const SentimentResultView = ({ result, siteId, historyId }: Props) => {
  // 前回結果との比較（前回値・変化量）。比較対象が無い場合は available=false
  const { data: comparison } = useLlmoComparisonApi({ site_id: siteId, history_id: historyId })
  const diff = comparison?.available ? comparison.diff : undefined

  const score = result.overall_score ?? 0
  const strengths = result.key_strengths ?? []
  const concerns = result.key_concerns ?? []
  const suggestions = result.improvement_suggestions ?? []

  return (
    <div className='flex flex-col'>
      {/* センチメント分布（ドーナツグラフ＋総合スコア・出現率テーブル） */}
      <GeoSection title='センチメント分布' subText='評判系プロンプトの回答内訳' noPadding>
        <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
          <div className='p-4'>
            <SentimentDistributionChart distribution={result.sentiment_distribution ?? {}} />
          </div>
          <div className='border-secondary flex flex-col gap-3 border-l'>
            <div className='p-4'>
              <GeoScoreCard
                title='総合センチメントスコア'
                value={signedScore(score)}
                valueColor={scoreTextColor(score)}
                previous={diff?.previous_score != null ? signedFixed(diff.previous_score) : null}
                change={diff?.score_change != null ? signedFixed(diff.score_change) : null}
              />
            </div>
            <SentimentDistributionTable distribution={result.sentiment_distribution ?? {}} />
          </div>
        </div>
      </GeoSection>

      {(result.competitor_comparison?.length ?? 0) > 0 && (
        <SentimentCompetitorTable competitors={result.competitor_comparison} />
      )}

      <SentimentPromptList items={result.brand_sentiments ?? []} />

      {(strengths.length > 0 || concerns.length > 0 || suggestions.length > 0) && (
        <SentimentInsightsPanel
          strengths={strengths}
          concerns={concerns}
          suggestions={suggestions}
        />
      )}
    </div>
  )
}

export default SentimentResultView
